// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectableFeature, SelectableType } from '@coa/app/shared/select-items-shared/models/selectable-feature';
import { DateRangeFilter } from '@coa/app/shared/filters/select-date-range/models/date-range-filter';
import { MatDialog } from '@angular/material/dialog';
import { AddToGroupDialogComponent } from '@coa/app/shared/add-to-group-dialog/components/add-to-group-dialog/add-to-group-dialog.component';

@Component({
  selector: 'coa-create-group-footer',
  templateUrl: './create-group-footer.component.html',
  styleUrls: ['./create-group-footer.component.scss'],
})
export class CreateGroupFooterComponent {
  @Input() sidenavCollapsed;
  @Input() selectableType: SelectableType;
  @Input() selections: string[];
  @Input() selectableFeature: SelectableFeature;
  @Input() clientId: string;
  @Input() dateRange: DateRangeFilter;

  feature = SelectableFeature;
  type = SelectableType;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
  ) {
  }

  cancel(): void {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        selections: undefined,
        selectable: undefined,
        selectableType: undefined,
        selectableFeature: undefined,
      },
      queryParamsHandling: 'merge',
    });
  }

  save(): void {
    this.dialog.open(AddToGroupDialogComponent, {data: {clientId: this.clientId, selections: this.selections}});
  }
}
